<template>
  <el-table :data="peas" @current-change="selectRow" >
    <el-table-column prop="id" label="PEA Number"></el-table-column>
    <el-table-column prop="urgency" label="Emergency">
      <template slot-scope="props">
        {{ props.row.urgency ? "Yes" : "No" }}
      </template>
    </el-table-column>
    <el-table-column prop="peaName" label="Name"></el-table-column>
    <el-table-column prop="createdDate" label="Created">
      <template slot-scope="props">
        {{ formatDate(props.row.createdDate) }}
      </template>
    </el-table-column>
    <el-table-column prop="projectEndDate" label="End Date">
      <template slot-scope="props">
        {{ formatDate(props.row.projectEndDate) }}
        </template>
    </el-table-column>
    <el-table-column prop="creatorName" label="Raised By"></el-table-column>
    <el-table-column prop="peaDivision" label="Division"></el-table-column>
    <el-table-column prop="peaDepartments" label="Departments">
      <template slot-scope="scope">
        <ul>
          <li v-for="department in scope.row.peaDepartments" v-bind:key="department.id">{{ department.name }}</li>
        </ul>
      </template>
    </el-table-column>
    <el-table-column prop="peaStatus" label="Status">
      <template slot-scope="scope">
        <status-icon :statusId="scope.row.peaStatusId"></status-icon> {{ scope.row.peaStatus }}
      </template>
    </el-table-column>
    <el-table-column prop="reason" label="Reason"></el-table-column>
    <el-table-column prop="netExpenditure" label="Estimated Cost">
      <template slot-scope="props">
        ${{ formatMoney(props.row.netExpenditure) }}
      </template>
    </el-table-column>
    <el-table-column prop="costToDate" label="Cost To Date">
      <template slot-scope="props">
        ${{ formatMoney(props.row.costToDate) }}
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
import router from '@/router'
export default {
  props: {
    peaData: {}
  },
  data () {
    return {
      peas: this.peaData
    }
  },
  methods: {
    formatMoney: function (money) {
      return helperMethods.formatMoney(parseFloat(money))
    },
    capitalize: function (input) {
      return input.charAt(0).toUpperCase() + input.slice(1)
    },
    formatDate: function (date) {
      return helperMethods.formatDate(helperMethods.convertDatetoISO(date))
    },
    selectRow: function (row) {
      router.push('/editPea/' + row.id)
    }
  }
}
</script>

<style lang="css">
</style>
